import { spawn } from 'redux-saga/effects';
import { authSaga } from './reducers/auth/saga';
import { gpsrSaga } from './reducers/gpsr/saga';

export function* rootSaga() {
	yield spawn(authSaga);
	yield spawn(gpsrSaga);
}
